/**
 * JWT 유틸리티
 */

interface JwtPayload {
  exp?: number; // Unix timestamp (seconds)
  iat?: number;
  [key: string]: any;
}

/**
 * JWT 토큰 디코드 (검증 없이 payload만 추출)
 */
export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

/**
 * JWT 토큰에서 만료시간 추출 (밀리초 단위)
 */
export function getTokenExpiresAt(token: string): number | null {
  const payload = decodeJwt(token);
  if (!payload?.exp) return null;
  return payload.exp * 1000; // seconds to milliseconds
}

/**
 * JWT 토큰 만료 여부 확인
 */
export function isTokenExpired(token: string): boolean {
  const expiresAt = getTokenExpiresAt(token);
  if (!expiresAt) return true;
  return Date.now() >= expiresAt;
}
